import React, { useEffect, useState } from 'react';
import styles from './container.module.scss';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import * as Yup from 'yup';
import { FormikProvider, useFormik } from 'formik';
import {
  useForward,
  useReply,
  useReplyAll,
  useSendMail,
} from '../../../../Hooks/Mail';
import { fileToBase64 } from './models/function';
import { toast } from 'react-toastify';

const EmailSchema = Yup.object().shape({
  to: Yup.array()
    .of(Yup.string().email('Invalid email'))
    .min(1, 'At least one recipient is required'),
  cc: Yup.array().of(Yup.string().email('Invalid email')),
  bodyHtml: Yup.string().required('Body is required'),
  signatureId: Yup.string(),
  subject: Yup.string().required('Subject is required'),
  attachments: Yup.array().of(Yup.mixed()),
  emailTemplateId: Yup.string(),
});

const SendMailContainer = ({
  isNewMail,
  setIsNewMail,
  setRefresh,
  reply,
  setReply,
  mailsType,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { mutate: SendMail, isLoading: isPending } = useSendMail();
  const { mutate: ReplyMail, isLoading: isReplying } = useReply();
  const { mutate: ReplyAll, isLoading: isReplyingAll } = useReplyAll();
  const { mutate: Forward, isLoading: isForward } = useForward();
  const onSuccessMail = () => {
    setIsNewMail(false);
    setIsExpanded(false);
    setRefresh(true);
    toast.success('Email sent successfully');
  };
  console.log('vfdvfd', reply);
  const formik = useFormik({
    initialValues: {
      to: reply?.content?.from?.address
        ? mailsType === 'Inbox'
          ? [reply.content.from.address]
          : reply.content.toRecipients?.map((i) => i.address) || []
        : [],
      cc:
        reply?.content?.ccRecipients?.length > 0 && reply.type === 'all'
          ? reply.content.ccRecipients.map((i) => i.address)
          : [],
      bodyHtml: reply.type === 'forward' ? reply?.content?.bodyContent : '',
      attachments:
        reply.type === 'forward'
          ? reply?.content?.attachments?.map((i) => ({
              name: i.name,
              type: i.contentType,
              fileContent: i.contentBytesBase64,
              edit: true,
            }))
          : [],
      signatureId: '',
      emailTemplateId: '',
      subject: reply?.content?.subject || '',
    },
    validationSchema: EmailSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        console.log('Vfdvdfv', values);
        const attachments = await Promise.all(
          values.attachments.map(async (file) => {
            if (file.edit) {
              return {
                fileName: file.name,
                contentType: file.type,
                base64: file.fileContent,
              };
            } else {
              const base64 = await fileToBase64(file);
              return {
                fileName: file.name,
                contentType: file.type,
                base64: base64?.fileContent,
              };
            }
          }),
        );

        console.log('cdvsdvsd', attachments);

        const payload = {
          ...values,
          attachments,
        };
        console.log('csdvsdv', payload);

        if (reply?.type === 'one') {
          ReplyMail(
            { id: reply?.content?.id, values: payload },
            {
              onSuccess: () => {
                resetForm();
                onSuccessMail();
              },
            },
          );
        } else if (reply?.type === 'all') {
          ReplyAll(
            { id: reply?.content?.id, values: payload },
            {
              onSuccess: () => {
                resetForm();
                onSuccessMail();
              },
            },
          );
        } else if (reply?.type === 'forward') {
          Forward(
            { id: reply?.content?.id, values: payload },
            {
              onSuccess: () => {
                resetForm();
                onSuccessMail();
              },
            },
          );
        } else {
          SendMail(payload, {
            onSuccess: () => {
              resetForm();
              onSuccessMail();
            },
          });
        }
      } catch (error) {
        console.error('Error processing attachments:', error);
      }
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, [isNewMail]);
  console.log('dnjdnd', formik);
  const content = (
    <>
      <Header
        setIsNewMail={setIsNewMail}
        setIsExpanded={setIsExpanded}
        isExpanded={isExpanded}
        setReply={setReply}
        reply={reply}
      />
      <Body reply={reply} setReply={setReply} />
      <Footer
        isPending={isPending || isReplying || isReplyingAll || isForward}
      />
    </>
  );

  return (
    <FormikProvider value={formik}>
      {isExpanded ? (
        <div className={styles['expanded_modal']}>
          {' '}
          <div className={styles['backdrop']}></div>
          <div className={`${styles['content']}`}>{content}</div>
        </div>
      ) : (
        <div
          className={`${styles.container} ${
            isNewMail ? styles['expanded'] : styles['collapsed']
          }`}
        >
          {content}
        </div>
      )}
    </FormikProvider>
  );
};

export default SendMailContainer;
